/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignVerticalJustifyCenter = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2" }],
    ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2" }],
    ["path", { d: "M2 12h20" }]
  ]
];

export { AlignVerticalJustifyCenter as default };
//# sourceMappingURL=align-vertical-justify-center.js.map
